module.exports = __webpack_public_path__ + "img/preloader.4f4a6d52.svg";